import { useEffect, useRef, useState } from "react"
import "../../App.scss"
import close from "./close.png"
import da from "./da.png"
import products from "./products.json"
import categories from "./categories.json"
import { Link, useLocation } from "react-router-dom"
import brands from "./brands.json"
import sb from "./sb.png"
import rb from "./reset.png"
import amazon from "./amazon.png"
import fb from "./filter.png"

function Shop() {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);



    const [brandSearchValue, setBrandSearchValue] = useState('')
    const [searchValue, setsearchValue] = useState(queryParams.get("searchValue") || "")
    const [selectedBrands, setSelectedBrands] = useState([]);

    const [showSearch, setShowSearch] = useState(false)

    const [catValue, setCatValue] = useState(queryParams.get("catValue") || "All Categories")







    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const openCats = () => {
        if (isOpen) {
            setIsOpen(false)
            setSelectedBrands([])
        }
        else {
            setIsOpen(true)
            setSelectedBrands([])
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // const handleSearch = () => {

    // }
    const [checkedCheckboxesOut, setCheckedCheckboxesOut] = useState([])


    // const handleCheckboxChange = (event) => {
    //     const brand = event.target.value;
    //     setSelectedBrands((prevSelectedBrands) => {
    //         if (prevSelectedBrands.includes(brand)) {
    //             return prevSelectedBrands.filter((b) => b !== brand);
    //         } else {
    //             return [...prevSelectedBrands, brand];
    //         }
    //     });

    // };

    const handleCheckboxChange = (event) => {
        const brand = event.target.value;

        setCheckedCheckboxesOut((prevSelectedBrands) => {
            if (prevSelectedBrands.includes(brand)) {
                return prevSelectedBrands.filter((b) => b !== brand);
            } else {
                return [...prevSelectedBrands, brand];
            }
        });
    }

    const [keywords, setKeywords] = useState([])

    const searchValueChange = (e) => {
        setsearchValue(e.target.value)
        setKeywords([])
    }

    const makeKeywords = () => {
        if (searchValue.trim().replace(/\s+/g, ' ').split(' ').length > 0) {
            const newKeywords = searchValue.trim().toLowerCase().replace(/\s+/g, ' ').split(' ');
            setKeywords(newKeywords);
            console.log(keywords)
        }
    }

    useEffect(() => {
        if (queryParams.get("searchValue")) {
            makeKeywords()
        }
    })

    const handleResetButtonClick = () => {
        // Reset selected brands to an empty array
        // setSelectedBrands([]);



        // Uncheck all checkboxes
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
        });

        if (checkedCheckboxesOut.length > 0) {
            setCheckedCheckboxesOut([])
            setCheckedCheckboxesOut(["1"])
        }
    };


    const [brandSearchBarShow, setBrandSearchBarShow] = useState(false)

    const [showLeftShopBox, setShowLeftShopBox] = useState(false)



    const handleShowSearchBar = () => {
        setBrandSearchBarShow(!brandSearchBarShow)
    }

    const closeFilterDiv = () => {
        document.getElementById("shopLeft").style.display = "none"

        if (checkedCheckboxesOut[0] == "1") {
            setSelectedBrands([])
            setCheckedCheckboxesOut([])
        }
        // setSelectedBrands([])
        // setCheckedCheckboxes([])
        // handleResetButtonClick()
    }

    const openFilterDiv = () => {
        document.getElementById("shopLeft").style.display = "flex"
        // setCheckedCheckboxes([])
        // setSelectedBrands([])
    }




    // Function to update selected brands array
    const updateSelectedBrands = async () => {
        // Update selected brands array based on the checked checkboxes
        const checkedCheckboxes = await document.querySelectorAll('input[type="checkbox"]:checked');
        const newSelectedBrands = await Array.from(checkedCheckboxes).map(checkbox => checkbox.value);
        await setSelectedBrands(newSelectedBrands);

        if (checkedCheckboxesOut[0] == "1") {
            setCheckedCheckboxesOut([])
            console.log("dsfds")
        }
        document.getElementById("shopLeft").style.display = "none"
        // closeFilterDiv()
    };







    return (
        <>
            <div id="shopLeft" className="shop-left-box">
                <div className="shop-left-box-main">
                    <div className="apply-div">
                        <button className={checkedCheckboxesOut.length > 0 ? "apply" : "apply disabled"} onClick={updateSelectedBrands} >Apply</button>
                        <img className="sb" onClick={closeFilterDiv} src={close} />
                    </div>
                    <div className="filter-head-div">
                        <div className="left-filter-head-div">
                            <p className="filterText" >Filter by brand :</p>
                        </div>
                        <div className="right-filter-head-div">
                            <img className="sb" onClick={handleShowSearchBar} src={sb} />
                            <img className="sb" onClick={handleResetButtonClick} src={rb} />
                        </div>
                    </div>
                    {
                        brandSearchBarShow ? (
                            <div className="filter-search-main">
                                <input id="brandSearchBar" type="text" value={brandSearchValue} onChange={(e) => { setBrandSearchValue(e.target.value) }} className="search-bar-brand" placeholder="Search brands" />

                                {
                                    brandSearchValue.length > 0 ? <img className="sbclose" onClick={() => { setBrandSearchValue('') }} src={close} /> : null
                                }
                            </div>
                        )
                            : null
                    }

                    <div className="brandsTotal" >
                        {
                            catValue == "All Categories"
                                ? (

                                    brandSearchValue.length > 0
                                        ? (
                                            brands.map((brand) => (

                                                brand[brand.name].map((b) => (
                                                    b.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(brandSearchValue.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                                                        ? (
                                                            <div className="brand-box">
                                                                <input
                                                                    type="checkbox"
                                                                    id={b}
                                                                    value={b}

                                                                    onChange={handleCheckboxChange}
                                                                />
                                                                <label className="brandName" >{b}</label>
                                                            </div>
                                                        )
                                                        : null
                                                ))

                                            ))
                                        )
                                        : (
                                            brandSearchValue.length == 0
                                                ? (
                                                    brands.map((brand) => (

                                                        brand[brand.name].map((b) => (
                                                            <div className="brand-box" >
                                                                <input
                                                                    type="checkbox"
                                                                    id={b}
                                                                    value={b}

                                                                    onChange={handleCheckboxChange}
                                                                />
                                                                <label className="brandName" >{b}</label>
                                                            </div>
                                                        ))

                                                    ))
                                                )
                                                : null
                                        )

                                )
                                : (

                                    brands.map((brand) => (
                                        brand.name == catValue
                                            ? (
                                                brandSearchValue.length > 0
                                                    ? (
                                                        brands.map((brand) => (

                                                            brand.name == catValue
                                                                ? (
                                                                    brand[brand.name].map((b) => (
                                                                        b.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(brandSearchValue.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                                                                            ? (
                                                                                <div className="brand-box">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id={b}
                                                                                        value={b}

                                                                                        onChange={handleCheckboxChange}
                                                                                    />
                                                                                    <label className="brandName" >{b}</label>
                                                                                </div>
                                                                            )
                                                                            : null
                                                                    ))
                                                                )
                                                                : null

                                                        ))
                                                    )
                                                    : (
                                                        brandSearchValue.length == 0
                                                            ? (
                                                                brands.map((brand) => (

                                                                    brand.name == catValue
                                                                        ? (
                                                                            brand[brand.name].map((b) => (
                                                                                b.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(brandSearchValue.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                                                                                    ? (
                                                                                        <div className="brand-box">
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id={b}
                                                                                                value={b}

                                                                                                onChange={handleCheckboxChange}
                                                                                            />
                                                                                            <label className="brandName" >{b}</label>
                                                                                        </div>
                                                                                    )
                                                                                    : null
                                                                            ))
                                                                        )
                                                                        : null

                                                                ))
                                                            )
                                                            : null
                                                    )
                                            )
                                            : null
                                    ))

                                )

                        }
                    </div>
                </div>

            </div>
            <div className="MainDiv">
                <div className="home-box">
                    <div className="input-div shop-input-div">
                        <div className="input-box shop-input-box">
                            <div class="dropdown" ref={dropdownRef}>
                                <div onClick={openCats} className="drpbox">
                                    <p class="dropbtn">{catValue}</p>
                                    <img className={isOpen ? "da daOpen" : "da"} src={da} />
                                </div>
                                {isOpen && (
                                    <div className="dropdown-content">
                                        {categories.map((ct, index) => (
                                            <p href="#" onClick={() => { setCatValue(ct); setIsOpen(false) }} key={index}>{ct}</p>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="search-field-box shop-search-field-box">
                                <input value={searchValue} onChange={(e) => { searchValueChange(e) }} className="search-field" placeholder={"Search in " + catValue} />
                                <>
                                    {
                                        searchValue.length > 0
                                            ? <img className="close" onClick={() => { setsearchValue(''); setKeywords([]) }} src={close} />
                                            : <p className="nullPara" ></p>
                                    }
                                    {
                                        searchValue.length > 0
                                            ? <button className="search-button" onClick={makeKeywords} >Search</button>
                                            : <button className="search-button disabled " >Search</button>
                                    }
                                </>

                            </div>
                        </div>



                    </div>
                    <div className="primary-shop">
                        <div className="filter-button-box">
                            {/* <p className="filter-result" >{selectedBrands.length > 0 ? "Filtered results" : "All results"}</p> */}
                            <div onClick={openFilterDiv} className={selectedBrands.length > 0 ? "filter-button activeFilter" : "filter-button"}>
                                <img className="fb" src={fb} />
                                <p className="filter-text-shop" > {selectedBrands.length > 0 ? "Filter mode on" : "Filter mode off"}</p>
                            </div>
                        </div>
                        <div className="main-shop-box">

                            <div className="shop-right-box">

                                <div className="products">

                                    {
                                        products.map((p) => (
                                            catValue == "All Categories" && keywords.length == 0 && selectedBrands.length == 0
                                                ? (
                                                    <Link className="product" to={"/shop/" + p.id} key={p.id}>

                                                        <div className="prod-upper">
                                                            <img className="prodImg" src={p.image} />
                                                        </div>
                                                        <div className="prod-lower">
                                                            <p className="prodName" >{p.name}</p>
                                                            <p className="prodCat"> in {p.category} by {p.brand}</p>

                                                        </div>

                                                    </Link>
                                                )
                                                : (
                                                    p.category == catValue && keywords.length == 0 && selectedBrands.length == 0
                                                        ? (
                                                            <div className="product" key={p.id}>
                                                                <div className="prod-upper">
                                                                    <img className="prodImg" src={p.image} />
                                                                </div>
                                                                <div className="prod-lower">
                                                                    <p className="prodName" >{p.name}</p>
                                                                    <p className="prodCat"> in {p.category} by {p.brand}</p>
                                                                </div>
                                                            </div>
                                                        )
                                                        : (
                                                            catValue === "All Categories" && keywords.length > 0 && selectedBrands.length === 0
                                                                ? (
                                                                    keywords.map((k) => (
                                                                        p.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(k.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) || p.category.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(k.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                                                                            ? (
                                                                                <div className="product" key={p.id}>
                                                                                    <div className="prod-upper">
                                                                                        <img className="prodImg" src={p.image} alt={p.name} />
                                                                                    </div>
                                                                                    <div className="prod-lower">
                                                                                        <p className="prodName">{p.name}</p>
                                                                                        <p className="prodCat"> in {p.category} by {p.brand} </p>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                            : null
                                                                    )).filter((value, index, self) => {
                                                                        const id = self[index]?.key;
                                                                        return self.findIndex((item) => item?.key === id) === index;
                                                                    })
                                                                )



                                                                : (
                                                                    p.category == catValue && keywords.length > 0 && selectedBrands.length == 0
                                                                        ? (
                                                                            p.category.toLowerCase().includes(catValue.toLowerCase())
                                                                                ? (
                                                                                    keywords.map((k) => (
                                                                                        p.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(k.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                                                                                            ? (
                                                                                                <div className="product" key={p.id}>
                                                                                                    <div className="prod-upper">
                                                                                                        <img className="prodImg" src={p.image} />
                                                                                                    </div>
                                                                                                    <div className="prod-lower">
                                                                                                        <p className="prodName" >{p.name}</p>
                                                                                                        <p className="prodCat"> in {p.category} by {p.brand}</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                            : null
                                                                                    )).filter((value, index, self) => {
                                                                                        const id = self[index]?.key;
                                                                                        return self.findIndex((item) => item?.key === id) === index;
                                                                                    })

                                                                                )
                                                                                : null
                                                                        )
                                                                        : catValue == "All Categories" && keywords.length == 0 && selectedBrands.length > 0
                                                                            ? (
                                                                                selectedBrands.includes(p.brand)
                                                                                    ? (
                                                                                        <div className="product" key={p.id}>
                                                                                            <div className="prod-upper">
                                                                                                <img className="prodImg" src={p.image} />
                                                                                            </div>
                                                                                            <div className="prod-lower">
                                                                                                <p className="prodName" >{p.name}</p>
                                                                                                <p className="prodCat"> in {p.category} by {p.brand}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                    : null
                                                                            )
                                                                            : catValue == "All Categories" && keywords.length > 0 && selectedBrands.length > 0
                                                                                ? (
                                                                                    selectedBrands.includes(p.brand)
                                                                                        ? (
                                                                                            keywords.map((k) => (
                                                                                                p.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(k.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) || p.category.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(k.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                                                                                                    ? (
                                                                                                        <div className="product" key={p.id} >
                                                                                                            <div className="prod-upper">
                                                                                                                <img className="prodImg" src={p.image} alt={p.name} />
                                                                                                            </div>
                                                                                                            <div className="prod-lower">
                                                                                                                <p className="prodName">{p.name}</p>
                                                                                                                <p className="prodCat"> in {p.category} by {p.brand}</p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )
                                                                                                    : null
                                                                                            )).filter((value, index, self) => {
                                                                                                const id = self[index]?.key;
                                                                                                return self.findIndex((item) => item?.key === id) === index;
                                                                                            })
                                                                                        )
                                                                                        : null
                                                                                )
                                                                                : p.category == catValue && keywords.length > 0 && selectedBrands.length > 0
                                                                                    ? (
                                                                                        selectedBrands.includes(p.brand) && p.category.includes(catValue)
                                                                                            ? (
                                                                                                keywords.map((k) => (
                                                                                                    p.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(k.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) || p.category.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(k.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
                                                                                                        ? (
                                                                                                            <div className="product" key={p.id}>
                                                                                                                <div className="prod-upper">
                                                                                                                    <img className="prodImg" src={p.image} alt={p.name} />
                                                                                                                </div>
                                                                                                                <div className="prod-lower">
                                                                                                                    <p className="prodName">{p.name}</p>
                                                                                                                    <p className="prodCat"> in {p.category} by {p.brand}</p>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )
                                                                                                        : null
                                                                                                )).filter((value, index, self) => {
                                                                                                    const id = self[index]?.key;
                                                                                                    return self.findIndex((item) => item?.key === id) === index;
                                                                                                })
                                                                                            )
                                                                                            : null
                                                                                    )
                                                                                    : p.category == catValue && keywords.length == 0 && selectedBrands.length > 0
                                                                                        ? (
                                                                                            selectedBrands.includes(p.brand) && p.category.includes(catValue)
                                                                                                ? (

                                                                                                    <div className="product" key={p.id}>
                                                                                                        <div className="prod-upper">
                                                                                                            <img className="prodImg" src={p.image} />
                                                                                                        </div>
                                                                                                        <div className="prod-lower">
                                                                                                            <p className="prodName" >{p.name}</p>
                                                                                                            <p className="prodCat"> in {p.category} by {p.brand}</p>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                )
                                                                                                : null
                                                                                        )
                                                                                        : null
                                                                )
                                                        )
                                                )
                                        ))
                                    }
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Shop